import { fetchWrapper } from '@/_helpers';

async function getSharedUserFormData({ userformdataId, chatroom }) {
    return fetchWrapper.get(
        `shared-userformdata?${userformdataId ? `userformdata=${userformdataId}` : ''}${chatroom ? `&chatroom=${chatroom}` : ''}`
    );
}

async function getSharedUserFormDataById({ sharedUserFormDataId, formAccessCode }) {
    if (formAccessCode) {
        return fetchWrapper.post(`shared-userformdata/${sharedUserFormDataId}`, { formAccessCode }, null, false);
    }
    return fetchWrapper.get(`shared-userformdata/${sharedUserFormDataId}`, false);
}

async function generateSharedUserFormLink({ payload }) {
    return fetchWrapper.post('shared-userformdata/generate-link', payload);
}

async function updateSharedUserFormData({ sharedUserFormDataId, payload }) {
    return fetchWrapper.put(`shared-userformdata/${sharedUserFormDataId}`, payload);
}

async function generateFormAccessCode({ sharedUserFormDataId }) {
    return fetchWrapper.post(`shared-userformdata/${sharedUserFormDataId}/access-code`);
}

async function removeFormAccessCode({ sharedUserFormDataId }) {
    return fetchWrapper.delete(`shared-userformdata/${sharedUserFormDataId}/access-code`);
}

export const sharedUserFormDataApi = {
    getSharedUserFormData,
    getSharedUserFormDataById,
    generateSharedUserFormLink,
    updateSharedUserFormData,
    generateFormAccessCode,
    removeFormAccessCode,
};
